import { useEffect } from 'react';
import { rowsPerPageOptions } from '../utils/constants';
export var useGridAutoRowsPerPage = function (_a) {
    var gridActions = _a.gridActions, queryRowsParam = _a.queryRowsParam, selectedRowsPerPage = _a.selectedRowsPerPage, autoRowsPerPage = _a.autoRowsPerPage, autoHeight = _a.autoHeight;
    useEffect(function () {
        var _a;
        if (!autoHeight || queryRowsParam || !autoRowsPerPage) {
            return;
        }
        var selectedOption = rowsPerPageOptions.find(function (option) { return option.value === selectedRowsPerPage; });
        if (!selectedOption) {
            if (autoRowsPerPage) {
                (_a = gridActions.setRowsPerPage) === null || _a === void 0 ? void 0 : _a.call(gridActions, autoRowsPerPage);
            }
        }
    }, [gridActions, queryRowsParam]);
};
